import React, { useEffect, useState } from "react";
// import "./FindMember.css";
// import "../CommonStyle.css";
// import "../../Styles/FindMember.css";
import "../../Styles/CommonStyles.scss";
import FMPersonalInfo from "../../components/FindMember/FMPersonalInfo";
import FMFirmAddress from "../../components/FindMember/FMFirmAddress";
import FMSections from "../../components/FindMember/FMSections";
import FMMemberTags from "../../components/FindMember/FMMemberTags";

import { Button, Label, SecondaryWhiteButton } from "../StyledComp/StyledComp";
import MemberServices from "../../services/MemberServices";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
// import { changeCurrentMemberMenu } from "../../store/screenSlice";
import { resetSearchParamFlags } from "../../store/hasSearchParamFlags";
// import { screenConfig } from "../../config/screenConfig";
import { resetSearchParameters } from "../../store/searchMemberApiSlice";
// import { PageLink } from "../../components/StyledComp/StyledComp";
// import { TextWrapper } from "../../globalStyles";
import { RootState } from "../../store/store";
import { useAppSelector } from "../../store/hooks";
import { IStateType } from "../../store/memberInterfaceStruct";
// import { isGeneratorFunction } from "util/types";
// import Modal from "react-modal";
import ReactModal from "react-modal";
// import InputField from "../StyledComp/InputField";
// import FindMemberMenu from "./FindMemberMenu";
import * as routeConfig from "../../config/routes";
import { setMemberCurrentPage } from "../../store/memberApiSlice";
import AlertWithModal from "../utilityComponents/AlertWithModal";

interface IConfiguration {
  [key: string]: any;
}

// interface ISaveSearchBody {
//   SearchName: string;
//   SearchParameters: IConfiguration;
// }

// const customStyles = {
//   content: {
//     top: "50%",
//     left: "50%",
//     right: "auto",
//     bottom: "auto",
//     marginRight: "-50%",
//     transform: "translate(-50%, -50%)",
//     backgroundColor: "white",
//     width: 400,
//   },
// };

const FindMember: React.FC = () => {
  const [configurationList, setConfigurationLists] = useState<IConfiguration>(
    {}
  );
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [modalOpen, setModalOpen] = useState(false);

  const [showAlertModal, setShowAlertModal] = useState<boolean>(false);
  const [alertBody, setAlertBody] = useState<string>("");
  const [alertTitle, setAlertTitle] = useState<string>("");

  const hasSearchParamFlags = useSelector(
    (state: RootState) => state.hasSearchParamFlags
  );
  const sectionNameArray = useSelector(
    (state: RootState) => state.searchMemberApiSlice.SectionIn ?? []
  );
  const executeNameArray = useSelector(
    (state: RootState) => state.searchMemberApiSlice.SectionNotIn ?? []
  );
  const tagsIn = useSelector(
    (state: RootState) => state.searchMemberApiSlice.TagIn ?? []
  );
  const tagsNotIn = useSelector(
    (state: RootState) => state.searchMemberApiSlice.TagsNotIn ?? []
  );
  useEffect(() => {
    dispatch(resetSearchParameters());
    dispatch(resetSearchParamFlags());
    dispatch(setMemberCurrentPage(1));

    const getConfigurationLists = async () => {
      console.log("getAdminList called");
      try {
        const response = await MemberServices.getConfigurationList();
        console.log("response...", response.data.data);
        if (response.data.data != null) {
          if (response.data.hasErrors) {
            setShowAlertModal(true);
            setAlertTitle("Database Error");
            setAlertBody(response.data.errors[0].sqlMessage);
            return;
          }
          console.log("Success");
          console.log("response1...", response.data.data);
          setConfigurationLists(response.data.data);
        } else {
          console.log("No configuration data received");
        }
      } catch (error) {
        console.error("Error loading configuration:", error);
        setShowAlertModal(true);
        setAlertTitle("Configuration Error");
        setAlertBody("Failed to load sections and tags. Please check your connection and try again.");
      }
    };

    getConfigurationLists();
  }, []);

  // const clearSearch = () => {
  //   dispatch(resetSearchParameters());
  //   dispatch(resetSearchParamFlags());
  // };

  let searchjson: IConfiguration = {};
  // let saveSearchbody: ISaveSearchBody = {
  //   SearchName: "",
  //   SearchParameters: {},
  // };

  const openMemberListScreen = async (
    event: React.FormEvent<HTMLFormElement>
  ) => {
    console.log("$$$$$$$$$$$$$$$$$$$$$$$$$$");
    console.log(openMemberListScreen);
    event.preventDefault();
    navigate(routeConfig.MEMBERS_URL, { replace: false });
    // dispatch(changeCurrentMemberMenu(screenConfig.memberListScreen));
  };
  // const data = useMemo(() => configurationList, [configurationList]);

  const openSavedSearchList = () => {
    navigate(routeConfig.MEMBERS_SAVEDSEARCH_URL, { replace: false });
    // dispatch(changeCurrentMemberMenu(screenConfig.savedSearchList));
  };

  const searchParameters: IStateType = useAppSelector(
    (state) => state.searchMemberApiSlice
  );

  const postSavedSearch = async () => {
    const response = await MemberServices.saveSearchQuery(searchjson);
    console.log("response...", response.data.data);
    if (response.data.data != null) {
      if (response.data.hasErrors) {
        setShowAlertModal(true);
        setAlertTitle("Database Error");
        setAlertBody(response.data.errors[0].sqlMessage);
        return;
      }
      console.log("Success");
    } else {
    }
  };

  const updateInput = (event: React.ChangeEvent<HTMLInputElement>): void => {
    createSearchParameters();
    console.log("searchjson2:", searchjson);
    searchjson["SearchName"] = event.target.value;
    console.log("searchjson3:", searchjson);
  };

  const createSearchParameters = () => {
    console.log("searchParameters1:", searchjson);
    for (let item in searchParameters) {
      if (searchParameters.hasOwnProperty(item)) {
        if (searchParameters[item] != null) {
          console.log("item:", item, ":", searchParameters[item]);
          searchjson[item] = searchParameters[item];
        }
      }
    }
    console.log("searchParameters2:", searchjson);
  };

  const isEmptySearch = (obj: any) => {
    return Object.keys(obj).length === 0;
  };
  const saveSearchParameters = () => {
    // saveSearchbody.SearchParameters = { searchjson };
    // searchjson.SearchName = "sunder search1";
    if (
      isEmptySearch(searchjson) ||
      (Object.keys(searchjson).length === 1 &&
        searchjson.hasOwnProperty("SearchName"))
    ) {
      alert("Enter Search value and Search name");
    } else {
      setModalOpen(false);
      alert("Search is saved successfully");

      console.log("searchjson4:", searchjson);
      console.log("search name:", searchjson.SearchName);
      console.log(isEmptySearch(searchjson));
      postSavedSearch();
    }
  };

  const closeFindMember = () => {
    // navigate(routeConfig.MEMBER_DETAIL_URL, { replace: false });
    navigate(routeConfig.MEMBERS_URL, { replace: false });
    // dispatch(changeCurrentMemberMenu(screenConfig.memberListScreen));
  };

  return (
    <div
      className="dashboard-wrapper-sticky-submit-button"
      style={{ paddingBottom: "20px", overflow: "auto" }}
    >
      <div className="dashboard-content-wrapper dashboard-wrapper-sticky-submit-button">
        <ReactModal
          isOpen={modalOpen}
          onRequestClose={() => setModalOpen(false)}
          className="saveSearchModal"
          overlayClassName="overlay"
        >
          <div className="horizontal-wrapper-spacebetween">
            <h1 className="page-heading">Save Search</h1>
          </div>
          <form className="form-wrapper">
            <div className="input-field-div-wrapper w-100">
              <Label>Save Search Name</Label>
              <input
                className="input-field-div"
                placeholder="Enter Name"
                id="SaveSearchName"
                name="SaveSearchName"
                onChange={updateInput}
              />
            </div>
          </form>
          <div className="button-wrapper">
            <div className="submit-button-div">
              <Button type="submit" onClick={saveSearchParameters}>
                Save
              </Button>
            </div>
          </div>
        </ReactModal>

        <div className="horizontal-wrapper-spacebetween">
          <h1 className="page-heading">Find Member</h1>
          <div
            className="horizontal-wrapper-rightaligned"
            style={{ width: "40%", marginTop: "0.5rem" }}
          >
            {/* <div className="secondary-button1">
              <SecondaryWhiteButton
                className="secondary-button_small"
                type="submit"
                onClick={() => {
                  closeFindMember();
                }}
              >
                <span style={{ fontWeight: "500" }}> Close</span>
              </SecondaryWhiteButton>
            </div> */}

            <div className="secondary-button1">
              <SecondaryWhiteButton
                className="secondary-button_small"
                type="submit"
                onClick={() => {
                  openSavedSearchList();
                }}
              >
                <span style={{ fontWeight: "500" }}> Saved Search</span>
              </SecondaryWhiteButton>
            </div>
          </div>
        </div>

        {/* Search parameter display */}
        {hasSearchParamFlags!.HasOtherSearchParam === true ||
        hasSearchParamFlags!.HasInSectionsSearchParam === true ||
        hasSearchParamFlags!.HasNotInSectionsSearchParam === true ||
        hasSearchParamFlags!.HasInTagsSearchParam === true ||
        hasSearchParamFlags!.HasNotInTagsSearchParam === true ? (
          <>
            <div className="horizontal-wrapper">
              <div className="heading_small">Selected Search keys:</div>
              {/* <div className="secondary-button_small" onClick={clearSearch}>
                <span>(Clear Search)</span>
              </div> */}
            </div>
            <div className="horizontal-wrapper" style={{ margin: "0.2rem" }}>
              {Object.entries(searchParameters).map(([key, value]) =>
                value != null &&
                value != "" &&
                key != "Sections" &&
                key != "Tags" &&
                key != "ExcludedSections" &&
                key != "ExcludedTags" &&
                key != "SectionIn" &&
                key != "TagIn" &&
                key != "SectionNotIn" &&
                key != "TagsNotIn" ? (
                  <div className="tag-style small-label">
                    {key} = <span style={{ color: "#3366cc" }}>{value}</span>
                  </div>
                ) : (
                  <></>
                )
              )}

              {hasSearchParamFlags.HasInSectionsSearchParam === true &&
              sectionNameArray.length > 0 ? (
                <div className="tag-style small-label">
                  IN Sections:
                  <span style={{ marginLeft: "0.5rem", color: "#3366cc" }}>
                    {sectionNameArray.join(", ")}
                  </span>
                  {/* {Object.entries(searchParameters).map(([key, value]) =>
                    configurationList.MemberSection != undefined ? (
                      configurationList.MemberSection.map((section: any) => {
                        return value != null &&
                          key === "Sections" &&
                          value.includes(section.Id) ? (
                          <span
                            style={{ marginLeft: "0.5rem", color: "#3366cc" }}
                          >
                            {section.SectionName},
                          </span>
                        ) : (
                          <></>
                        );
                      })
                    ) : (
                      <></>
                    )
                  )} */}
                </div>
              ) : (
                <></>
              )}
              {hasSearchParamFlags.HasNotInSectionsSearchParam === true &&
              executeNameArray.length > 0 ? (
                <div className="tag-style small-label">
                  NOT IN Sections:
                  <span style={{ marginLeft: "0.5rem", color: "#3366cc" }}>
                    {executeNameArray.join(", ")}
                  </span>
                  {/* {Object.entries(searchParameters).map(([key, value]) =>
                    configurationList.MemberSection != undefined ? (
                      configurationList.MemberSection.map((section: any) => {
                        return value != null &&
                          key === "ExcludedSections" &&
                          value.includes(section.Id) ? (
                          <span
                            style={{ marginLeft: "0.5rem", color: "#3366cc" }}
                          >
                            {section.SectionName},
                          </span>
                        ) : (
                          <></>
                        );
                      })
                    ) : (
                      <></>
                    )
                  )} */}
                </div>
              ) : (
                <></>
              )}
              {hasSearchParamFlags.HasInTagsSearchParam === true &&
              tagsIn.length > 0 ? (
                <div className="tag-style small-label">
                  IN Tags:
                  <span style={{ marginLeft: "0.5rem", color: "#3366cc" }}>
                    {tagsIn.join(", ")}
                  </span>
                  {/* {Object.entries(searchParameters).map(([key, value]) =>
                    configurationList.MemberTag != undefined ? (
                      configurationList.MemberTag.map((tags: any) => {
                        return value != null &&
                          key === "Tags" &&
                          value.includes(tags.Id) ? (
                          <span
                            style={{ marginLeft: "0.5rem", color: "#3366cc" }}
                          >
                            {tags.MemberTag},
                          </span>
                        ) : (
                          <></>
                        );
                      })
                    ) : (
                      <></>
                    )
                  )} */}
                </div>
              ) : (
                <></>
              )}
              {hasSearchParamFlags.HasNotInTagsSearchParam === true &&
              tagsNotIn.length > 0 ? (
                <div className="tag-style small-label">
                  NOT IN Tags:
                  <span style={{ marginLeft: "0.5rem", color: "#3366cc" }}>
                    {tagsNotIn.join(", ")}
                  </span>
                  {/* {Object.entries(searchParameters).map(([key, value]) =>
                    configurationList.MemberTag != undefined ? (
                      configurationList.MemberTag.map((tags: any) => {
                        return value != null &&
                          key === "ExcludedTags" &&
                          value.includes(tags.Id) ? (
                          <span
                            style={{ marginLeft: "0.5rem", color: "#3366cc" }}
                          >
                            {tags.MemberTag},
                          </span>
                        ) : (
                          <></>
                        );
                      })
                    ) : (
                      <></>
                    )
                  )} */}
                </div>
              ) : (
                <></>
              )}
            </div>
          </>
        ) : (
          <></>
        )}

        <form onSubmit={(e) => openMemberListScreen(e)}>
          <FMPersonalInfo
            MemberCode={configurationList.MemberCode}
            MemberType={configurationList.MemberTypes}
          />
          <FMFirmAddress StateList={configurationList.StateList} />
          <FMSections Sections={configurationList.MemberSection} />
          <FMMemberTags Tags={configurationList.MemberTag} />
          <div className="submit-floating-button-div">
            <div className="horizontal-wrapper-centeralign">
              <Button
                className="submit-button-div"
                type="submit"
                // onClick={openMemberListScreen}
              >
                Search
              </Button>

              {/* <PageLink
              style={{
                paddingLeft: "1rem",
                width: "15rem",
                alignSelf: "center",
              }}
              onClick={() => {
                // createSearchParameters();
                setModalOpen(true);
              }}
            > */}
              <div className="secondary-button1">
                <SecondaryWhiteButton
                  className="secondary-button_small"
                  type="button"
                  onClick={() => {
                    // createSearchParameters();
                    setModalOpen(true);
                  }}
                >
                  <span style={{ fontWeight: "500" }}> Save Search</span>
                </SecondaryWhiteButton>
              </div>
            </div>
          </div>
        </form>
      </div>
      {showAlertModal ? (
        <AlertWithModal
          title={alertTitle}
          body={alertBody}
          show={showAlertModal}
          onClose={() => setShowAlertModal(false)} // Close the modal
        />
      ) : (
        <></>
      )}
    </div>
  );
};

export default FindMember;
